import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { EndCustomers } from "../end-customer/end-customer.entity";
import { PaymentMode } from "../payment-mode/payment-mode.entity";
import { ShippingTerms } from "../shipping-terms/shipping-terms.entity";
import { Customers } from "./customers.entity";

@Entity('address')
export class Address {

  @PrimaryGeneratedColumn("increment", { name: 'address_id' })
  addressId: number;
  @Column("varchar", {
    nullable: false,
    length: 100,
    name: "add_line_one"
  })
  addLineOne: string;

  @Column("varchar", {
    nullable: false,
    length: 100,
    name: "add_line_two"
  })
  addLineTwo: string;

  @Column("varchar", {
    nullable: true,
    length: 100,
    name: "add_line_three"
  })
  addLineThree: string;
  @Column("varchar", {
    nullable: true,
    length: 100,
    name: "add_line_four"
  })
  addLineFour: string;

  @Column("varchar", {
    nullable: false,
    name: "add_type"
  })
  addressType: string;
  @Column("int", {
    nullable: true,
    name: "end_customer_id"
  })
  endCustomerId: number;
  @Column("int", {
    nullable: true,
    name: "cust_id"
  })
  CustId: number;
  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user",
    default:'Admin',
    length: 50
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 50
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(type => Customers, customer => customer.cusAddressInfo, { nullable: true, onDelete: "CASCADE", })
  @JoinColumn({ name: "cust_id" })
  customerInfo: Customers | null;

  @ManyToOne(type => EndCustomers, endCustomers => endCustomers.addressInfo, { nullable: true, onDelete: "CASCADE", })
  @JoinColumn({ name: "end_customer_id" })
  endCustomerInfo: EndCustomers | null;

}
